import React from "react";

export const Modal: React.FC = ({ children }) => (
  <div className="flex justify-center items-center fixed left-0 top-0 w-screen h-screen">
    <div className="p-3 w-1/2 bg-component">{children}</div>
  </div>
);
